import { BottomSectionDisplay } from './bottomSectionDisplay';

const props = [];

export const BottomSectionDisplayDirective = reactDirective => reactDirective(BottomSectionDisplay, props);
BottomSectionDisplayDirective.$inject = ['reactDirective'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('bottomSectionDisplay', BottomSectionDisplayDirective);
